import {Component, ElementRef, OnInit} from '@angular/core';
import {LangChange} from '../../../../lang-change';
import {Principal} from '../../../../common/services/principal';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Language} from '../../../../common/models/language';
import {EnrollCabinet} from '../model/enroll-cabinet';
import {CenterNationalityService} from '../../../user/services/center-nationality.service';
import {DictionaryService} from '../../../shared/services/dictionary.service';
import {Utils} from '../../../../common/services/Utils';
import {EnrollApplicationService} from '../../../common-main/services/enroll-application.service';
import {ModuleENUM} from '../../../../common/enums/module.enum';
import {EnrolleListService} from '../../../user/services/enrolle-list.service';
import {ApplicantStatusEnum} from '../../../../common/enums/applicant-status.enum';
import {PublicationStatusEnum} from '../../../../common/enums/publication-status.enum';
import {UniversityApplicantInfo} from '../model/university-applicant-info';
import {MatDialog} from '@angular/material';
import {CommonDialogComponent} from './dialogs/common-dialog/common-dialog.component';
import {EsuvoOptionService} from '../../../shared/services/esuvo-option.service';
import {DicsEnrollCabinet} from '../model/dics-enroll-cabinet';
import {EnrollCabinetValidation} from './enroll-cabinet-validation';
import {CenterProfessionService} from '../../../../common_services/center-profession.service';
import {AlternativeCollegeItem} from './tabs/enroll-entrans-info/model/alternative-college-item';
import {AlternativeCollegesService} from 'app/modules/enroll/services/alternative-colleges.service';
import {ProfessionService} from '../../../../common_services/profession.service';
import {SimpleObject} from '../../../../common/dtos/SimpleObject';
import {EdsService} from '../../../shared/services/eds.service';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import {ApplicationSubmission} from '../model/application-submission';
import {ConfirmDialogComponent} from '../../../../common/dialogs/confirm-dialag/confirm-dialag.component';

declare const $: any;

@Component({
  selector: 'app-enroll-cabinet',
  templateUrl: './enroll-cabinet.component.html',
  styleUrls: ['./enroll-cabinet.component.scss']
})
export class EnrollCabinetComponent extends LangChange implements OnInit {

  enrollId: any = 0;
  collegeId: any = 0;
  public enrollCabinet: EnrollCabinet;
  public applicationStatus: any[] = [];
  public eduOrgNameFromBackend: any = null;
  public dics: DicsEnrollCabinet = new DicsEnrollCabinet();
  public validationErrors: any = [];
  applicationFormDisabled = false;
  isTechSecretary = false;
  applicationInfo: UniversityApplicantInfo = new UniversityApplicantInfo();
  documents_received = false;
  documents_returned = false;
  documents_returned_alternative_college_grant = false;
  statusInfo = {
    confirmingWithoutDocuments: false,
    sendingToRevision: false,
    sendingToRevisionContent: '',
    rejectingApplication: false,
    rejectingApplicationReason: '',
    rejectingGrant: true,
    rejectingGrantReason: '',
  };
  interviewData = {
    date: null,
    time: null
  };
  hasAllowPublishEnterExams = false;
  isAvailableTotalScoreEntranceExamsInPublish = false;
  isAvailablePaymentFormInPublish = false;
  iinAlreadyHasInSystem: SimpleObject;
  settingList: any;
  settingsApplicantStatusesForPublish: any[] = [];
  applicantStatusesForTransferToAlternativeCollege: any[] = [];

  setAlternativeColleges = false;
  alternativeColleges: AlternativeCollegeItem[] = [];
  checkEDS = false;
  eventsSubject: Subject<void> = new Subject<void>();
  isUniversityWorker = true;
  applicationSubmissionCompletedMessage = '';
  alternativeCollegesDictionary: any[] = [];
  alternativeCollegesProfessions: any[] = [];
  alternativeCollegesQualificationArrays: any[] = [];
  mainCollegeNamesDic: any[] = [];
  mainCollegeProfessionsDic: any[] = [];
  mainCollegeQualificationDic: any[] = [];
  actualizeData = false;
  grantCompletionMessage = '';

  constructor(private elRef: ElementRef,
              private _route: Router,
              private route: ActivatedRoute,
              public _translateService: TranslateService,
              private _principal: Principal,
              private _utils: Utils,
              private _optionsService: EsuvoOptionService,
              private _nationalityService: CenterNationalityService,
              private _professionService: ProfessionService,
              private _centerProfessionService: CenterProfessionService,
              private _dictionaryService: DictionaryService,
              private _enrollApplicationService: EnrollApplicationService,
              private _enrolleListService: EnrolleListService,
              private _enrollCabinetValidation: EnrollCabinetValidation,
              private _alternativeCollegesService: AlternativeCollegesService,
              private _edsService: EdsService,
              private _esuvoOptionService: EsuvoOptionService,
              private dialog: MatDialog) {

    super(_translateService);
    this.dics.currLang = _translateService.currentLang;
    this.isTechSecretary = _principal.getAccessByModuleId(ModuleENUM.ENROLLE);
    this.isUniversityWorker = this._principal.getUserCollegeId() > 0;
    this.route.params.subscribe(params => {
      this.enrollId = +params['enrollId'];
      // this.collegeId = +params['collegeId'];
    });
    if (!this.isTechSecretary) {
      this.collegeId = this._principal.getUser().collegeId;
    }
    this._utils.blockStart();
    this.loadDictionaries();
    this.loadApplicationData();
  }

  loadApplicationData() {// грузим инфу о заявке абитуриента
    this._enrollApplicationService.getApplication((this.enrollId ? this.enrollId : 0)).subscribe(res => {
      if (res.data) {
        console.log(res.data);
        this.enrollCabinet = res.data;
        if (this.enrollCabinet.finalGrant != null && this.enrollCabinet.finalGrant >= 0) {
          this.getGrantCompletionMessage();
        }
        this.applicationSubmissionCompletedMessage = this.enrollCabinet.applicationSubmissionCompletedMessage;

        this.loadEnrollInfo();
        if (this.enrollCabinet.centerCollege) Language.updateLocalizedName(this.enrollCabinet.centerCollege);
        this.collegeId = this.enrollCabinet.collegeId;
        if (!this.enrollId) {
          this.enrollId = this.enrollCabinet.enrollId;
        }
        this.enrollCabinet.isCurrentUserApplicant = this.isUniversityWorker && this.enrollCabinet.enrollId > 0
          && (this.enrollCabinet.collegeId > 0 && this._principal.getUserCollegeId() == this.enrollCabinet.collegeId
            || this.enrollCabinet.userCollegeId > 0 && this._principal.getUserCollegeId() == this.enrollCabinet.userCollegeId) || this.enrollCabinet.enrollId == 0;

        if (this.enrollCabinet.edu_info.edu_institute_graduate === 3 && //  закончил ВУЗ
          this.enrollCabinet.edu_info.edu_graduate_domestic === 1) { // закончил ВУЗ в Казахстане
          if (this.enrollCabinet.edu_info.edu_graduate_domestic_operating_univ === 1) { // действующий ВУЗ
            // парсим в тип int так как с бэка приходит в строковом
            this.enrollCabinet.edu_info.edu_graduate_domestic_univ_name = Number.parseInt(this.enrollCabinet.edu_info.edu_graduate_domestic_univ_name);
            this.enrollCabinet.edu_info.edu_graduate_domestic_univ_spec = Number.parseInt(this.enrollCabinet.edu_info.edu_graduate_domestic_univ_spec);
          }
        }
        if (!this.enrollCabinet.edu_info.edu_institute_country) {
          this.enrollCabinet.edu_info.edu_institute_country = 113;
        }
        if (res.additional) {
          this.applicationStatus = res.additional;
          this.checkIsFormDisabled();
        }
        this.loadCenterProfession();
        this.loadEducatedList();
      }
      this._utils.blockStop();
    }, err => {
      console.log('getApplication err', err);
      this._utils.blockStop();
    });
  }


  onLangChange(language: Language): void {
    this.dics.nationalities = this._utils.translateListWithSort(this.dics.nationalities, 'name');
    this.dics.foreign_lang_degrees = this._utils.translateListWithSort(this.dics.foreign_lang_degrees, 'name');
    this.dics.citizenship = this._utils.translateListWithSort(this.dics.citizenship, 'name');
    this.dics.ictype = this._utils.translateListWithSort(this.dics.ictype, 'name');
    this.dics.icdepartament = this._utils.translateListWithSort(this.dics.icdepartament, 'name');
    this.dics.edu_institute_place = this._utils.translateListWithSort(this.dics.edu_institute_place, 'name');
    this.dics.universities = this._utils.translateListWithSort(this.dics.universities, 'name');
    this.dics.universities_professions = this._utils.translateListWithSort(this.dics.universities_professions, 'name');
    this.dics.centerProfessions = this._utils.translateListWithSort(this.dics.centerProfessions, 'name');
    this.dics.study_forms = this._utils.translateListWithSort(this.dics.study_forms, 'name');
    this.dics.payment_forms = this._utils.translateListWithSort(this.dics.payment_forms, 'name');
    this.dics.study_languages = this._utils.translateList(this.dics.study_languages, 'name');
    this.dics.benefits = this._utils.translateListWithSort(this.dics.benefits, 'name');
    this.dics.quotas = this._utils.translateListWithSort(this.dics.quotas, 'name');
    this.dics.military_status = this._utils.translateListWithSort(this.dics.military_status, 'name');
    this.dics.military_office_residence = this._utils.translateListWithSort(this.dics.military_office_residence, 'name');
    this.dics.departments = this._utils.translateListWithSort(this.dics.departments, 'name');
  }

  ngOnInit() {
    this.loadAppStatusesForPublication();
    this.loadApplicationInfo();
    Language.updateListLocalizedName(this.dics.edu_institute_place);
    Language.updateListLocalizedName(this.dics.language);
    // this.hideStatusAlert();
    this.checkApplyWithEDS();
  }

  hideStatusAlert() {
    setTimeout(() => {
      const hElement: HTMLElement = this.elRef.nativeElement;
      const allDivs = hElement.getElementsByClassName('status-alert');
      if (allDivs.length > 0) {
        for (let i = 0; i < allDivs.length; i++) {
          allDivs.item(i).className = 'hide';
        }
      }
    }, 10000);
  }

  loadAppStatusesForPublication() {
    this._optionsService.getOptionDto('ALLOW_PUBLISH_OF_ENTER_EXAMS_ON_PEM_WEBSITE').subscribe(data => {
      if (data) this.hasAllowPublishEnterExams = data.booleanValue;
    });
    this._optionsService.getCommonSettings().subscribe(settings => {
      this.settingList = settings;
      this.dics.settingList = settings;
      this.settingsApplicantStatusesForPublish = JSON.parse(this.getValueByCode('STATUSES_FOR_PUBLISH_OF_ENTER_EXAMS_ON_PEM_WEBSITE'));
      this.applicantStatusesForTransferToAlternativeCollege = JSON.parse(this.getValueByCode('STATUSES_FOR_TRANSFER_TO_ALTERNATIVE_COLLEGE'));
      const requireDocScans = this.settingList.find(item => (Object.is(item.code, 'MAKE_NONREQUIRED_UPLOAD_DOCUMENTS_SCANS')));
      if (!!requireDocScans) {
        this.dics.nonRequireDocScans = requireDocScans.booleanValue;
      }
      const requireBenefitsDocScans = this.settingList.find(item => (Object.is(item.code, 'REQUEST_MANDATORY_CONFORMATION_OF_BENEFITS')));
      if (!!requireBenefitsDocScans) {
        this.dics.requireBenefitsDocScans = requireBenefitsDocScans.booleanValue;
      }
    });
  }
  getValueByCode(code): any {
    const ret = this.settingList.find(item => (Object.is(item.code, code)));
    return (ret) ? ret.value : [];
  }

  loadApplicationInfo() { // грузим информацию о заявке если тех секретарь
    if (this.isTechSecretary && this.enrollId > 0) {
      this._enrolleListService.getApplicationInfo(this.enrollId).subscribe(data => {
        if (data) {
          this.applicationInfo = data;
          this.getApplicationInfoStatus(data);
          this.isAvailableTotalScoreEntranceExamsInPublish = this.applicationInfo.publication_status === PublicationStatusEnum.NOT_PUBLISHED_ENTRANCE_EXAM_RESULTS;
          this.isAvailablePaymentFormInPublish = this.applicationInfo.publication_status === PublicationStatusEnum.PUBLISHED_PAYMENT_FORM;
        }
      }, error => {
        console.log('_enrolleListService.loadApplicationInfo() error:', error);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      });
    }
  }

  getApplicationInfoStatus(data): any {
    if (data && this.enrollCabinet) {
      this.checkIsFormDisabled();
      const user = `${this.enrollCabinet.personal_info.surname} ${this.enrollCabinet.personal_info.firstname}`;
      switch (data.status) {
        case ApplicantStatusEnum.RECEIVED_ON_PEM :
          return this.createApplicationInfoStatus('application_statuses.APP_RECEIVED_ON_PEM', data.saved_time, user);
        case ApplicantStatusEnum.SAVED_NOT_SUBMITTED :
          return this.createApplicationInfoStatus('application_statuses.APP_SAVED_NOT_SUBMITTED', data.saved_time, (data.saved_person > 0 && data.reception_status == 11 ? data.saved_user ? data.saved_user.fullName : '' : user) );
        case ApplicantStatusEnum.SUBMITTED :
          return this.createApplicationInfoStatus('application_statuses.APP_SUBMITTED', data.submittedTime, (data.submitted_person > 0 && data.reception_status == 11 ?  data.submitted_user ? data.submitted_user.fullName : '' : user ));
        case ApplicantStatusEnum.RECOVERED :
          return this.createApplicationInfoStatus('application_statuses.APP_RECOVERED', data.recovered_time, data.recovered_user.fullName);
        case ApplicantStatusEnum.CONFIRMED_WITHOUT_DOCUMENTS :
          return this.createApplicationInfoStatus('application_statuses.APP_CONFIRMED_WITHOUT_DOCUMENTS', data.confirmed_without_documents_time, data.confirmed_without_documents_user.fullName);
        case ApplicantStatusEnum.CONFIRMED_WITH_DOCUMENTS :
          this.documents_received = true;
          return this.createApplicationInfoStatus('application_statuses.APP_CONFIRMED_WITH_DOCUMENTS', data.confirmed_with_documents_time, (data.confirmed_with_documents_user ? data.confirmed_with_documents_user.fullName : null));
        case ApplicantStatusEnum.SENT_TO_REVISION :
          return this.createApplicationInfoStatus('application_statuses.APP_SENT_TO_REVISION', data.sent_to_revision_time, data.sent_to_revision_user.fullName);
        case ApplicantStatusEnum.CORRECTED :
          return this.createApplicationInfoStatus('application_statuses.APP_CORRECTED', data.corrected_time, (data.data.corrected_user ? data.data.corrected_user.fullName : null));
        case ApplicantStatusEnum.REJECTED :
          return this.createApplicationInfoStatusAdditional('application_statuses.APP_REJECTED', data.rejected_time, data.rejected_user.fullName, data.rejectedReason);
        case ApplicantStatusEnum.ARCHIVED :
          this.documents_returned = true;
          return this.createApplicationInfoStatus('application_statuses.APP_ARCHIVED', data.archived_time, data.archived_user.fullName);
      }
    }
    return {status: '', date: null, user: null};
  }

  createApplicationInfoStatus(status, date, user) {
    return {
      status: this._translateService.instant(status),
      date: (date ? date : ''),
      user: (user ? user : null)
    };
  }

  createApplicationInfoStatusAdditional(status, date, user, additional) {
    return {
      status: this._translateService.instant(status),
      date: (date ? date : ''),
      user: (user ? user : null),
      additional: (additional ? additional : '')
    };
  }

  loadDictionaries() {
    this._nationalityService.getAll().subscribe(data => {
      this.dics.nationalities = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _nationalityService.getAll() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this._dictionaryService.getDicTablesByIdList(1).subscribe(data => {
        this.dics.foreign_lang_degrees = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getDicTablesByIdList(1) error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this._dictionaryService.getCitizenshipList().subscribe(data => {
        this.dics.citizenship = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getCitizenshipList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this._dictionaryService.getICTypeList().subscribe(data => {
        this.dics.ictype = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getICTypeList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this._dictionaryService.getIcDepartmentList().subscribe(data => {
        this.dics.icdepartament = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getIcDepartmentList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this._dictionaryService.getUniversitiesList().subscribe(data => {
        this.dics.universities = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getUniversitiesList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this._dictionaryService.getAllUniversitiesProfessionList().subscribe(data => {
        this.dics.universities_professions = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getAllUniversitiesProfessionList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );



    /*this._dictionaryService.getStudyFormsList(this.collegeId).subscribe(data => {
      data = data.filter( h => h.id !== 1 && h.id !== 2); // удаляем записи "Дневная" и "Заочная"
      this.dics.study_forms = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getStudyFormsList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );*/
    this._dictionaryService.getPaymentFormList().subscribe(data => {
        this.dics.payment_forms = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getPaymentFormList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this._dictionaryService.getCenterStudyLanguagesList().subscribe(data => {
        this.dics.study_languages = this._utils.translateList(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getCenterStudyLanguagesList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this._dictionaryService.getAllCenterProfessionList().subscribe(data => {
        this.dics.centerProfessions = this._utils.translateList(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getCenterStudyLanguagesList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this._dictionaryService.getBenefitsList().subscribe(data => {
        this.dics.benefits = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getBenefitsList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this._dictionaryService.getQuotasDictList({used: true}).subscribe(data => {
        this.dics.quotas = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getBenefitsList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this._dictionaryService.getDicTablesByIdList(2).subscribe(data => {
        this.dics.military_status = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getDicTablesByIdList(2) error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this._dictionaryService.getMilitaryOfficeResidenceList().subscribe(data => {
        this.dics.military_office_residence = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getMilitaryOfficeResidenceList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
    this._dictionaryService.getDepartmentsDictList().subscribe(data => {
        this.dics.departments = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getDepartmentsDictList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
  }

  saveApplication(simpleSave) { // нажатие на "Сохранить"
    this._utils.confirmDialog({message: 'enroll_cabinet_page.saving_of_application_notification'}, () => {
      this.checkIINExists().subscribe(value => {
        if (this.validateMainForm() && value) {
          if (this.applicationStatus.indexOf('SAVED_NOT_SUBMITTED') > -1 || this._principal.isEnroll()) { // если абитуриент
            this._enrollCabinetValidation.normalizeFrom(this.enrollCabinet).then(value1 => { // нормализуем форму для отправки
              this.doSaveApplication(simpleSave); // сохраняем
            });
          } else if (this.isTechSecretary) { // если тех секретать, валидируем форму
            if (this.validateForm()) {
              this._enrollCabinetValidation.normalizeFrom(this.enrollCabinet).then(value1 => { // нормализуем форму для отправки
                this.doSaveApplication(simpleSave); // сохраняем
              });
            }
          }
        } else {
          // this._utils.notifyError('fill_in_all', null);
          this.gotoPageElement('page-header');
        }
      }, reason => {
        console.log('EnrollCabinetComponent saveApplication() error:', reason);
      });
    });
  }

  updateApplication() {
    this.validationErrors = [];
    this.enrollCabinet.alternativeColleges = this.alternativeColleges;
    // this.actualizeData = true;
    if (this._enrollCabinetValidation.validateInRanging(this.enrollCabinet, this.validationErrors,
      this.mainCollegeNamesDic, this.mainCollegeProfessionsDic, this.mainCollegeQualificationDic,
      this.setAlternativeColleges, this.alternativeCollegesDictionary, this.alternativeCollegesProfessions, this.alternativeCollegesQualificationArrays)) {
      this.checkIINExists().subscribe(value => {
        if (this.validateMainForm() && value && this.validateForm()) {
          if (this.checkEDS) {
            this._edsService.signXmlCall('<data></data>', (signedXml) => {
              if (signedXml) {
                this.enrollCabinet.signedXml = signedXml;
                this.doSaveApplication(true);
              }
            });
          } else {
            this.doSaveApplication(true);
          }
        }
      });
    } else {
      this.gotoPageElement('page-header');
    }
  }


  doSaveApplication(simpleSave) {// метод сохранения
    this.validationErrors = [];
    this.enrollCabinet.personal_info.reg_place = null;
    this.enrollCabinet.simpleSave = simpleSave;
    if (this.validationErrors.length === 0) {
      this._utils.blockStart();
      this.enrollCabinet.alternativeColleges = this.alternativeColleges;
      this._enrollApplicationService.saveApplication(this.enrollCabinet, (this.enrollId ? this.enrollId : 0)).subscribe(
        response => {
          if (response.status === 'SUCCESS') {
            if (!this.enrollCabinet.finalGrant) {
              this.enrollCabinet.preliminaryGrant = null;
            }
            if (this.enrollCabinet.enrollId == 0 && response.data) {
              this.enrollId = response.data;
              this.enrollCabinet.enrollId = response.data;
              this._route.navigateByUrl(`user/requests/enrolle/${this.enrollCabinet.enrollId}/0`);
            }
            this.checkApplicationSubmission(true).subscribe(applicationSubmissionMessage => {
              if (applicationSubmissionMessage && applicationSubmissionMessage.length > 0) {
                this.applicationSubmissionCompletedMessage = applicationSubmissionMessage;
                this.gotoPageElement('page-header');
              }
            });
            this.applicationStatus = [];
            if (response.additional && response.additional.includes('EMAIL_CHANGED')) {
              this._utils.notifySuccess('saved', ['ВНИМАНИЕ! При следующей авторизации в поле «Логин» используйте новый адрес электронной почты']);
              const index = response.additional.findIndex(d => d === 'EMAIL_CHANGED');
              response.additional.splice(index, 1);
            } else {
              this._utils.notifySaved(true);
            }
            if (response.additional) {
              this.applicationStatus = response.additional;
              this.checkIsFormDisabled(); // проверка на деактивацию формы, если заявка подана то форму делаем только чтение
              /*if (!this.validateForm() && !this.enrollCabinet.fromEgov) { // валидируем форму
                this.validationErrors = [];
                this.applicationStatus.push('SAVED_NOT_SUBMITTED_ADDITIONAL');
              }*/
              this.gotoPageElement('page-header');
            }
            this.hideStatusAlert();
            if (this.dics.authority.alternativelyEduCount > 0) {
              this._alternativeCollegesService.saveAlternativeColleges((this.setAlternativeColleges ? this.alternativeColleges : []), this.enrollId).subscribe(data => {
                if (!!data && !!data['data']) {
                  this.loadEnrollAlternativeColleges();
                }
                this._utils.blockStop();
              });
            } else {
              this._utils.blockStop();
            }
            this.loadApplicationInfo();
          } else if (response.status === 'ERROR') {
            if (response.additional && response.additional.includes('EMAIL_DUPLICATE')) {
              this._utils.notifyError(this._translateService.instant('email_duplicate_error'), null);
            } else if (response.additional && response.additional.includes('EMAIL_ERROR')) {
              this._utils.notifyError('common.error_on_save', ['Указан несуществующий адрес электронной почты. Пожалуйста, укажите корректный и актуальный адрес']);
            } else {
              this._utils.notifyError('common.error_on_save', null);
              console.log('saveApplication error', response);
            }
            this._utils.blockStop();
          } else if (response.status === 'WARNING') {
            this._utils.notifyError(this._translateService.instant(response.description), null);
            this._utils.blockStop();
          } else {
            this._utils.blockStop();
          }
        }, error => {
          this._utils.blockStop();
          console.log('saveApplication error', error);
        });
    } else {
      this._utils.notifyError('fill_in_all', null);
      this.gotoPageElement('page-header');
    }
  }

  sendApplication() {
    this._utils.blockStart();
    this.enrollCabinet.alternativeColleges = this.alternativeColleges;
    this._enrollApplicationService.sendApplication(this.enrollCabinet).subscribe(
      response => {
        if (response.status === 'SUCCESS') {
          this.applicationStatus = [];
          if (response.additional && response.additional.includes('EMAIL_CHANGED')) {
            this._utils.notifySuccess('enroll_cabinet_page.send_application_success', ['ВНИМАНИЕ! При следующей авторизации в поле «Логин» используйте новый адрес электронной почты']);
            const index = response.additional.findIndex(d => d === 'EMAIL_CHANGED');
            response.additional.splice(index, 1);
          } else {
            this._utils.notifySuccess('enroll_cabinet_page.send_application_success', '');
          }
          if (response.additional) {
            this.applicationStatus = response.additional;
            this.checkIsFormDisabled();
            this.gotoPageElement('page-header');
            this.hideStatusAlert();
          }
          if (this.dics.authority.alternativelyEduCount > 0) {
            this._alternativeCollegesService.saveAlternativeColleges((this.setAlternativeColleges ? this.alternativeColleges : []), this.enrollId).subscribe(data => {
              if (!!data && !!data['data']) {
                this.loadEnrollAlternativeColleges();
              }
              this._utils.blockStop();
            });
          } else {
            this._utils.blockStop();
          }
          this.loadApplicationInfo();
        }
        if (response.status === 'ERROR') {
          if (response.additional && response.additional.includes('EMAIL_DUPLICATE')) {
            this._utils.notifyError(this._translateService.instant('email_duplicate_error'), null);
          } else if (response.additional && response.additional.includes('EMAIL_ERROR')) {
            this._utils.notifyError('common.error_on_save', ['Указан несуществующий адрес электронной почты. Пожалуйста, укажите корректный и актуальный адрес']);
          } else {
            this._utils.notifyError('common.error_on_save', response.additional);
          }
          this._utils.blockStop();
        }

        if (response.status === 'WARNING') {
          this._utils.notifyError(this._translateService.instant(response.description), null);
          this._utils.blockStop();
        }
      }, error => {
        console.log('saveApplication error', error);
        this._utils.blockStop();
      });
  }
  onSubmit(applicationForm) {  // нажатие на "Подать"
    this.validationErrors = [];
    //  поле Место окончания учебного заведения – Село и Форма оплаты бесплатная и нет квоты ,
    // то система должна установить сельскую Квоту
    if (this.enrollCabinet.edu_info.edu_institute_place == 2 && this.enrollCabinet.entrance_info.payment_form == 2 &&
      (this.enrollCabinet.quota.quotaid == 0 || this.enrollCabinet.quota.quotaid == undefined)) {
      this.enrollCabinet.quota.quotaid = 3;
    }
    this.checkIINExists().subscribe(value => {
      if (value) {
        this.checkApplicationSubmission().subscribe(applicationSubmissionMessage => {
          if (applicationSubmissionMessage && applicationSubmissionMessage.length > 0) {
            this.applicationSubmissionCompletedMessage = applicationSubmissionMessage;
            this.gotoPageElement('page-header');
          } else {
            if (this.validateForm()) {
              if (this.enrollCabinet.edu_info.attestat && this.enrollCabinet.edu_info.attestat.attestat_average_ball) {
                this.enrollCabinet.edu_info.attestat.attestat_average_ball = this.enrollCabinet.edu_info.attestat.attestat_average_ball.toString().replace(',', '.');
              }
              if (this.checkEDS) {
                this._edsService.signXmlCall('<data></data>', (signedXml) => {
                  if (signedXml) {
                    this.enrollCabinet.signedXml = signedXml;
                    this.sendApplication();
                  }
                });
              } else {
                this.sendApplication();
              }
            } else {
              this._utils.notifyError('fill_in_all', null);
              this.gotoPageElement('page-header');
            }
          }
        });
      }
    });

  }

  validateForm(): boolean {
    if (this.checkEDS && !this.isTechSecretary) {
      if ((this.enrollCabinet.personal_info.citizenship != 113 && this.enrollCabinet.personal_info.has_iin == 0)) {
        this.checkEDS = false;
      }

      const birthdayDay = new Date(this.enrollCabinet.personal_info.birth_date).getDay();
      const birthdayMonth = new Date(this.enrollCabinet.personal_info.birth_date).getMonth();
      const birthdayYear = new Date(this.enrollCabinet.personal_info.birth_date).getFullYear();
      let age = new Date().getFullYear() - birthdayYear;
      if ((new Date().getMonth() + 1) < birthdayMonth || (new Date().getMonth() + 1) == birthdayMonth && new Date().getDate() < birthdayDay) {
        age--;
      }

      let parenthasIIN = false;
      if (age < 18 && this.checkEDS) {
        this.enrollCabinet.personal_info.parents.forEach(p => {
          if ((p.citizenship === 113 || p.has_iin === 1) && p.iin && !parenthasIIN) {
            parenthasIIN = true;
          }
          this.checkEDS = parenthasIIN;
        });
        if (!parenthasIIN) {
          this.validationErrors.push('enroll_cabinet_page.personal_info_tab.parents');
        }
      }
    }
    return this._enrollCabinetValidation.validateForm(this.enrollCabinet, this.validationErrors, this.dics, this.isTechSecretary, this._principal.isEnroll(), this._utils, this._enrollApplicationService, this._principal.getUserCollegeId())
      && this._enrollCabinetValidation.validateEnrollAlternativeColleges(this.alternativeColleges, this.validationErrors, this.setAlternativeColleges, this.enrollCabinet, this.isTechSecretary);
  }

  checkApplyWithEDS() {
    this._esuvoOptionService.getOptionDto('APPLICANT_MUST_SIGN_WITH_EDS_WHEN_SUBMITING_APPLICATION').subscribe(data => {
      this.checkEDS = data.booleanValue;
    });
  }

  private validateMainForm(): boolean  {
    this.validationErrors = [];
    return this._enrollCabinetValidation.validateMainForm(this.enrollCabinet, this.validationErrors, this.isTechSecretary, this._principal.getUserCollegeId());
  }

  checkIINExists() {
    this.iinAlreadyHasInSystem = null;
    return new Observable<boolean>(observer  => {
      if (this.enrollCabinet.personal_info.iin && this.enrollCabinet.personal_info.citizenship === 113 || this.enrollCabinet.personal_info.has_iin === 1) {
        this._enrollApplicationService.checkHasIIN(this.enrollCabinet.enrollId, this.enrollCabinet.personal_info.iin).subscribe(data => {
          if (data) {
            this.iinAlreadyHasInSystem = data;
          }
          if (this.iinAlreadyHasInSystem && this.iinAlreadyHasInSystem.name && this.iinAlreadyHasInSystem.name.length > 0) {
            this._translateService.get('enroll_cabinet_page.personal_info_tab.iin_already_has_in_system', {status: this.getStatusName(this.iinAlreadyHasInSystem.id), collegeName: this.iinAlreadyHasInSystem.name})
              .subscribe(translation => {
                this._utils.notifyError(translation, '');
              });
            observer.next(false);

          } else {
            observer.next(true);
          }
        });
      } else {
        observer.next(true);
      }
    });
  }

  checkApplicationSubmission(save?: boolean) {
    this.applicationSubmissionCompletedMessage = null;
    return new Observable<string>(observer => {
      const applicationSubmission = new ApplicationSubmission();
      applicationSubmission.paymentFormId = this.enrollCabinet.entrance_info.payment_form;
      applicationSubmission.grantTypeId = this.enrollCabinet.entrance_info.grant_type;
      applicationSubmission.educatedId = this.enrollCabinet.edu_info.edu_received;
      // applicationSubmission.studyFormId = ; TODO добавить форму обучения
      applicationSubmission.departmentId = this.enrollCabinet.entrance_info.department_id;

      if (this.enrollCabinet.entrance_info.speciality && this.enrollCabinet.entrance_info.speciality > 0) {
        applicationSubmission.professions.push(this.enrollCabinet.entrance_info.speciality);
      }
      if (this.enrollCabinet.entrance_info.qualification && this.enrollCabinet.entrance_info.qualification > 0) {
        applicationSubmission.qualifications.push(this.enrollCabinet.entrance_info.qualification);
      }

      if (this.setAlternativeColleges) {
        for (const alternativeCollege of this.alternativeColleges) {
          if (alternativeCollege.specId && alternativeCollege.specId > 0) {
            applicationSubmission.professions.push(alternativeCollege.specId);
          }
          if (alternativeCollege.qualificationId && alternativeCollege.qualificationId > 0) {
            applicationSubmission.qualifications.push(alternativeCollege.qualificationId);
          }
        }
      }

        this._enrollApplicationService.checkApplicationSubmission(applicationSubmission).subscribe(message => {
          observer.next(message);
        });
    });
  }

  cancelSendingApplication(applicationForm) { // отменить подачу заявления
    this._enrollApplicationService.cancelSendApplication(this.enrollCabinet).subscribe(
      response => {
        if (response.status === 'SUCCESS') {
          this._utils.notifySaved(true);
          if (response.additional) {
            this.applicationStatus = response.additional;
            this.checkIsFormDisabled();
            this.loadApplicationInfo();
          }
        }
        if (response.status === 'ERROR') {
          this._utils.notifyError('common.error_on_save', null);
          console.log('saveApplication error', response);
        }
      }, error => {
        console.log('saveApplication error', error);
      });
  }

  cancelConfirmedApplication(applicationForm) { // отменить подачу заявления
    this._enrollApplicationService.cancelConfirmedApplication(this.enrollCabinet).subscribe(
      response => {
        if (response.status === 'SUCCESS') {
          this._utils.notifySaved(true);
          if (response.additional) {
            this.applicationStatus = response.additional;
            this.checkIsFormDisabled();
            this.loadApplicationInfo();
          }
        }
        if (response.status === 'ERROR') {
          this._utils.notifyError('common.error_on_save', null);
          console.log('saveApplication error', response);
        }
      }, error => {
        console.log('saveApplication error', error);
      });
  }

  gotoPageElement(el) {
    const element = document.getElementById(el);
    if (element) {
      element.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'nearest'});
    }
  }

  checkIsFormDisabled() { // проверка деактивации формы
    this.applicationFormDisabled = false;
    if (this.isTechSecretary) {
      this.applicationFormDisabled = this.applicationStatus.indexOf('SAVED_NOT_SUBMITTED') == -1
        && !(this.applicationInfo.status === ApplicantStatusEnum.CONFIRMED_WITHOUT_DOCUMENTS
        || this.applicationInfo.status === ApplicantStatusEnum.CONFIRMED_WITH_DOCUMENTS)
        || !this.isUniversityWorker || !this.enrollCabinet.isCurrentUserApplicant || this.enrollCabinet && this.enrollCabinet.finalGrant != null && this.enrollCabinet.finalGrant >= 0;
    } else if (this.applicationStatus.indexOf('SUBMITTED') > -1 ||
      this.applicationStatus.indexOf('CORRECTED') > -1 ||
      this.applicationStatus.indexOf('CONFIRMED_WITHOUT_DOCUMENTS') > -1 ||
      this.applicationStatus.indexOf('CONFIRMED_WITH_DOCUMENTS') > -1) {
      this.applicationFormDisabled = true;
    }
  }

  isEditableForApplicant() {
    if (!this.applicationInfo) return false;
    return !this.applicationFormDisabled;
  }

  isConfirmed() {
    if (!this.isTechSecretary || !this.applicationInfo  || (this.enrollCabinet != null && this.enrollCabinet.finalGrant != null && this.enrollCabinet.finalGrant >= 0 && !(this.enrollCabinet.grantRejectionStatus && this.enrollCabinet.grantRejectionStatus.length > 0))) return false;
    const status = this.applicationInfo.status;
    return status === ApplicantStatusEnum.CONFIRMED_WITH_DOCUMENTS || status === ApplicantStatusEnum.CONFIRMED_WITHOUT_DOCUMENTS;
  }

  canSave() {
    if (!this.isTechSecretary || !this.applicationInfo || this.enrollCabinet && this.enrollCabinet.finalGrant != null && this.enrollCabinet.finalGrant >= 0) return false;
    const status = this.applicationInfo.status;
    return status === ApplicantStatusEnum.CONFIRMED_WITHOUT_DOCUMENTS || status === ApplicantStatusEnum.CONFIRMED_WITH_DOCUMENTS;
  }

  canCancel() {
    if (!this.isTechSecretary || !this.applicationInfo || this.enrollCabinet && this.enrollCabinet.finalGrant != null && this.enrollCabinet.finalGrant >= 0) return false;
    const status = this.applicationInfo.status;
    return status === ApplicantStatusEnum.SUBMITTED || status === ApplicantStatusEnum.RECOVERED
      || status === ApplicantStatusEnum.SENT_TO_REVISION || status === ApplicantStatusEnum.CORRECTED;
    // || status === ApplicantStatusEnum.CONFIRMED_WITHOUT_DOCUMENTS;
  }

  canConfirm() {
    if (!this.isTechSecretary || !this.applicationInfo) return false;
    const status = this.applicationInfo.status;
    return status === ApplicantStatusEnum.SUBMITTED || status === ApplicantStatusEnum.RECOVERED
      || status === ApplicantStatusEnum.CORRECTED || status === ApplicantStatusEnum.SENT_TO_REVISION;
  }

  canSendToRevision() {
    if (!this.isTechSecretary || !this.applicationInfo) return false;
    const status = this.applicationInfo.status;
    return status === ApplicantStatusEnum.SUBMITTED || status === ApplicantStatusEnum.RECOVERED
      || status === ApplicantStatusEnum.CORRECTED ;
  }

  canReject() {
    if (!this.isTechSecretary || !this.applicationInfo  || this.enrollCabinet && this.enrollCabinet.finalGrant != null && this.enrollCabinet.finalGrant >= 0) return false;
    const status = this.applicationInfo.status;
    return status === ApplicantStatusEnum.SUBMITTED || status === ApplicantStatusEnum.RECOVERED
      || status === ApplicantStatusEnum.CORRECTED || status === ApplicantStatusEnum.SENT_TO_REVISION
      || status === ApplicantStatusEnum.CONFIRMED_WITHOUT_DOCUMENTS;
  }

  canSaveAndSign() {
    if (!this.isTechSecretary || !this.applicationInfo) return false;
    const status = this.applicationInfo.status;
    return status === ApplicantStatusEnum.CONFIRMED_WITH_DOCUMENTS || status === ApplicantStatusEnum.CONFIRMED_WITHOUT_DOCUMENTS;
  }

  canRecover() {
    if (!this.isTechSecretary || !this.applicationInfo) {
      return false;
    }
    const status = this.applicationInfo.status;
    return status === ApplicantStatusEnum.REJECTED || status === ApplicantStatusEnum.ARCHIVED;
  }

  isConfirmedWithDocuments() {
    return this.applicationInfo.status === ApplicantStatusEnum.CONFIRMED_WITH_DOCUMENTS;
  }

  showEntranceExamDatas() {
    if (!this.isTechSecretary || !this.applicationInfo) return false;
    const status = this.applicationInfo.status;
    return status === ApplicantStatusEnum.CONFIRMED_WITHOUT_DOCUMENTS || status === ApplicantStatusEnum.CONFIRMED_WITH_DOCUMENTS
      || status === ApplicantStatusEnum.RECOVERED || status === ApplicantStatusEnum.CORRECTED;
  }

  // Принять заявление
  receiveApplication() {
    this._utils.confirmDialog({message: 'enroll_application_operations.receive_confirmation'}, () => {
      this._utils.blockStart();
      this.updateApplicationStatus(ApplicantStatusEnum.CONFIRMED_WITHOUT_DOCUMENTS, null, 'enroll_application_operations.application_received').then(value => {
        console.log('updateApplicationStatus CONFIRMED_WITHOUT_DOCUMENTS');
        this.documents_received = false;
        this.documents_returned = false;
      }, reason => {
      });
    });
  }

  // Отправить заявление на доработку
  sendApplicationToRevision() {
    this.dialog.closeAll();
    const dialogRef = this.getCommonDialogComponent('enroll_application_operations.send_to_revision_dialog_title', 'enroll_application_operations.send_to_revision', 1);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (this.statusInfo.sendingToRevisionContent) {
          this._utils.confirmDialog({message: 'enroll_application_operations.send_to_revision_confirm'}, () => {
            this._utils.blockStart();
            this.statusInfo.sendingToRevision = true;
            this.updateApplicationStatus(ApplicantStatusEnum.SENT_TO_REVISION, this.statusInfo.sendingToRevisionContent, 'enroll_application_operations.sended_to_revision')
              .then(value => {
                this.statusInfo.sendingToRevision = false;
              }, reason => {
                this.statusInfo.sendingToRevision = false;
              });
          });
        }
      }
    });

  }

  // Отклонить
  rejectApplication() {
    this.dialog.closeAll();
    const dialogRef = this.getCommonDialogComponent('enroll_application_operations.reject_dialog_title', 'enroll_application_operations.reject', 2);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (this.statusInfo.rejectingApplicationReason) {
          this._utils.confirmDialog({message: 'enroll_application_operations.reject_confirm'}, () => {
            this._utils.blockStart();
            this.statusInfo.rejectingApplication = true;
            this.updateApplicationStatus(ApplicantStatusEnum.REJECTED, this.statusInfo.rejectingApplicationReason, 'enroll_application_operations.rejected')
              .then(value => {
                this.statusInfo.rejectingApplication = false;
              }, reason => {
                this.statusInfo.rejectingApplication = false;
                this._utils.notifyError('enroll_application_operations.not_rejected', null);
              });
          });
        }
      }
    });
  }

  // Восстановить
  recoverApplication() {
    this._utils.confirmDialog({message: 'enroll_application_operations.recover_confirm'}, () => {
      this._utils.blockStart();
      this.statusInfo.rejectingApplication = true;
      this.updateApplicationStatus(ApplicantStatusEnum.RECOVERED, null, 'enroll_application_operations.recovered')
        .then(value => {
          this.documents_returned = false;
        }, reason => {
          this._utils.notifyError('error_occurred', null);
        });
    });
  }

  // Дата вступительных экзаменов
  saveApplicationEntranceExamsDate() {
    this._enrolleListService.getSubjectsForAdmission(this.enrollId).subscribe(value => {
      if (value) {
        this.dics.admissionSubjects = value.data;
        this.dialog.closeAll();
        const dialogRef = this.getCommonDialogComponent('enroll_application_operations.admission_exams_date_dialog_title', 'save', 3);
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.examsData) {
            this._enrolleListService.saveSubjectAdmissionDates(result.examsData.admissionSubjects).subscribe(data => {
              if (data.status === 'SUCCESS') {
                this._utils.notifySaved(true);
              } else {
                this._utils.notifySaved(false);
                console.error('saveApplicationEntranceExamsDate() saveSubjectAdmissionDates error', data.description);
              }
            });
          }
        }, err => {
          this._utils.notifySaved(false);
          console.error('saveApplicationEntranceExamsDate() saveSubjectAdmissionDates error', err);
        });
      } else {

      }
    });
  }

  // Опубликовать результаты экзаменов
  publishApplicationEntranceExams(publish: boolean, type: number) {
    const applicants = [];
    applicants.push(this.enrollId);
    if (publish) {
      const confirm = (type === 1 ? 'enroll_application_operations.publish_entrance_exams.exams_results_publish_confirm' :
        'enroll_application_operations.publish_entrance_exams.payment_form_publish_confirm');
      this._utils.confirmDialog({message: confirm}, () => {
        this._enrolleListService.publishEnrollApplication(applicants, type).subscribe(data => {
          this._utils.notifySaved((data.status === 'SUCCESS'));
          this.loadApplicationInfo();
        });
      });
    } else {
      const confirm = (type === 1 ? 'enroll_application_operations.publish_entrance_exams.exams_results_unpublish_confirm' :
        'enroll_application_operations.publish_entrance_exams.payment_form_unpublish_confirm');
      this._utils.confirmDialog({message: confirm}, () => {
        this._enrolleListService.cancelPublishEnrollApplication(applicants, type).subscribe(data => {
          this._utils.notifySaved((data.status === 'SUCCESS'));
          this.loadApplicationInfo();
        });
      });
    }
  }

  applicationDocumentsReceived() {
    if (this.applicationInfo.status === ApplicantStatusEnum.CONFIRMED_WITH_DOCUMENTS) return;
    this._utils.confirmDialog({message: 'enroll_application_operations.documents_received_confirm'}, () => {
      console.log('applicationDocumentsReceived confirmDialog()');
      this._utils.blockStart();
      this.updateApplicationStatus(ApplicantStatusEnum.CONFIRMED_WITH_DOCUMENTS, null, 'enroll_application_operations.documents_originals_received')
        .then(value => {
          this.documents_received = true;
          return;
        }, reason => {
          this.documents_received = false;
          this._utils.notifyError('error_occurred', null);
        });
    }, () => {
      this.documents_received = false;
    });
  }

  applicationDocumentsReturned(motive = null) {
    if (this.applicationInfo.status === ApplicantStatusEnum.ARCHIVED) return;
    const confirmDialogMessage = motive == null ? 'enroll_application_operations.documents_returned_confirm' : this.getDocumentReturnMessage();
    this._utils.confirmDialog({message: confirmDialogMessage}, () => {
      this._utils.blockStart();
      this.updateApplicationStatus(ApplicantStatusEnum.ARCHIVED, motive, 'enroll_application_operations.documents_originals_returned')
        .then(value => {
          this.documents_returned = true;
          if (!!motive) this.documents_returned_alternative_college_grant = true;
        }, reason => {
          this.documents_returned = false;
          if (!!motive) this.documents_returned_alternative_college_grant = false;
          this._utils.notifyError('error_occurred', null);
        });
    }, () => {
      this.documents_returned = false;
      if (!!motive) this.documents_returned_alternative_college_grant = false;
    });
  }

  getCommonDialogComponent(title: string, sendButtonTitle: string, type: number) {
    return this.dialog.open(CommonDialogComponent, {
      data: {
        title: title,
        type: type,
        send_button_title: sendButtonTitle,
        enrollCabinet: this.enrollCabinet,
        applicationInfo: this.applicationInfo,
        statusInfo: this.statusInfo,
        interviewData: this.interviewData,
        dics: this.dics
      }
    });
  }

  updateApplicationStatus(status: number, reason ?: string, successMessage ?: string) { // обновление статуса заявки
    return new Promise((resolve, reject) => {
      const applicationInfo = Object.assign({}, this.applicationInfo);
      applicationInfo.status = status;
      const dto = {applicantInfo: applicationInfo, reason: (reason ? reason : '')};
      this._enrolleListService.updateApplicationInfo(dto).subscribe(resp => {
        this._utils.blockStop();
        this._utils.checkMessage(resp, succ => {
          let additional = '';
            this.loadApplicationInfo();
            if (resp.data && resp.data.emailStatus == 0) {
              additional = this._translateService.instant('email_change_status_not_sent');
            }
          this._utils.notifySuccess(successMessage, additional);
            resolve(resp);
          }, err => {
            this._utils.notifyMessage(resp, null, null);
          }
        );
      }, err => {
        console.error('updateApplicationStatus() _enrolleListService.updateApplicationInfo ERROR: ', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
        reject(err);
      });
    });
  }


  isCanBePublished(item) {
    if (this.isPublished(item)) return false;
    if (this.settingsApplicantStatusesForPublish && item) {
      if (!!item.applicantInfo) {
        return (this.settingsApplicantStatusesForPublish.findIndex(value => {
          return Object.is(value, this.getApplicantStatusEnumName(item.applicantInfo.status));
        }) > -1);
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isCanBeTransfer() {
    return (this.applicantStatusesForTransferToAlternativeCollege.findIndex(value => {
      return Object.is(value, this.getApplicantStatusEnumName(this.applicationInfo.status));
    }) > -1);
  }

  isPublished(item) {
    if (!!item.applicantInfo && !!item.applicantInfo.publication_status) {
      return (item.applicantInfo.publication_status === PublicationStatusEnum.PUBLISHED_PAYMENT_FORM || item.applicantInfo.publication_status === PublicationStatusEnum.PUBLISHED_ENTRANCE_EXAM_RESULTS);
    }
    return false;
  }

  getApplicantStatusEnumName(status): any {
    switch (status) {
      case ApplicantStatusEnum.SAVED_NOT_SUBMITTED : return 'SAVED_NOT_SUBMITTED';
      case ApplicantStatusEnum.SUBMITTED : return 'SUBMITTED';
      case ApplicantStatusEnum.RECOVERED : return 'RECOVERED';
      case ApplicantStatusEnum.CONFIRMED_WITHOUT_DOCUMENTS : return 'CONFIRMED_WITHOUT_DOCUMENTS';
      case ApplicantStatusEnum.CONFIRMED_WITH_DOCUMENTS : return 'CONFIRMED_WITH_DOCUMENTS';
      case ApplicantStatusEnum.SENT_TO_REVISION : return 'SENT_TO_REVISION';
      case ApplicantStatusEnum.CORRECTED : return 'CORRECTED';
      case ApplicantStatusEnum.REJECTED : return 'REJECTED';
      case ApplicantStatusEnum.ARCHIVED : return 'ARCHIVED';
    }
  }

  eventFromEnrollEntransInfo($event) {
    this.setAlternativeColleges = $event.setAlternativeColleges;
    this.alternativeColleges = $event.alternativeColleges;
    this.alternativeCollegesDictionary = $event.alternativeCollegesDictionary;
    this.alternativeCollegesProfessions = $event.alternativeCollegesProfessions;
    this.alternativeCollegesQualificationArrays = $event.alternativeCollegesQualificationArrays;
    this.mainCollegeNamesDic = $event.mainCollegeNamesDic;
    this.mainCollegeProfessionsDic = $event.mainCollegeProfessions;
    this.mainCollegeQualificationDic = $event.mainCollegeSpecializations;
    this.actualizeData = false;
    console.log('actualized');
  }

  loadEnrollAlternativeColleges() {
    this.eventsSubject.next();
  }

  changeCabinetFunction($event) {
    if ($event.functionName === 'loadCenterProfession') {
      this.loadCenterProfession();
    } else if ($event.functionName === 'resetAlternativeColleges') {
      this.resetAlternativeColleges();
    } else if ($event.functionName === 'loadAlternativeCollegeProfessions') {
      this.loadAlternativeCollegeProfessions();
    } else if ($event.functionName === 'loadEducatedList') {
      this.loadEducatedList();
    }
  }

  loadCenterProfession() {
    const filter = {
      hasCount: true,
      studyLanguageId: this.enrollCabinet.entrance_info.learn_lang,
      educatedId: this.enrollCabinet.edu_info.edu_received
    };
    if (this.enrollCabinet.entrance_info.learn_lang && this.enrollCabinet.edu_info.edu_received &&
      this.enrollCabinet.entrance_info.payment_form === 2) {
      this._centerProfessionService.getCenterProfessionsWithGrant(filter).subscribe(data => {
          this.dics.professions = this._utils.translateListWithSort(data, 'name');
          this.dics.professions.map((i) => {
            i.fullName = i.code + ' ' + i.name;
            return i;
          });
          this.loadAlternativeCollegeProfessions();
        }, err => {
          console.log('EnrollCabinetComponent _centerProfessionService.getListByCollegeId() error', err);
          this._utils.notifyError(this._translateService.instant('error_occurred'), '');
        }
      );
    } else if (this.enrollCabinet.entrance_info.payment_form === 1) {
      this._enrollApplicationService.getCenterProfessionsByRegion().subscribe(data => {
        this.dics.professions = data.filter(p => p.classifierType == 1 || p.classifierType == 2);
        Language.updateListLocalizedName(this.dics.professions);
        this.dics.professions.map((i) => {
          i.fullName = i.code + ' ' + i.name;
          if (i.classifierType == 2) {
            i.fullName += ' (прикладной бакалавр)';
          }
          return i;
        });
      });
    }
  }

  getStatusName(status) {
    switch (status) {
      case ApplicantStatusEnum.SAVED_NOT_SUBMITTED :
        return this._translateService.instant('application_statuses.APP_SAVED_NOT_SUBMITTED');
      case ApplicantStatusEnum.SUBMITTED :
        return this._translateService.instant('application_statuses.APP_SUBMITTED');
      case ApplicantStatusEnum.RECOVERED :
        return this._translateService.instant('application_statuses.APP_RECOVERED');
      case ApplicantStatusEnum.CONFIRMED_WITHOUT_DOCUMENTS :
        return this._translateService.instant('application_statuses.APP_CONFIRMED_WITHOUT_DOCUMENTS');
      case ApplicantStatusEnum.CONFIRMED_WITH_DOCUMENTS :
        return this._translateService.instant('application_statuses.APP_CONFIRMED_WITH_DOCUMENTS');
      case ApplicantStatusEnum.SENT_TO_REVISION :
        return this._translateService.instant('application_statuses.APP_SENT_TO_REVISION');
      case ApplicantStatusEnum.CORRECTED :
        return this._translateService.instant('application_statuses.APP_CORRECTED');
      case ApplicantStatusEnum.REJECTED :
        return this._translateService.instant('application_statuses.APP_REJECTED');
      case ApplicantStatusEnum.ARCHIVED :
        return this._translateService.instant('application_statuses.APP_ARCHIVED');
    }
  }

  private loadEnrollInfo() {
    this.enrollCabinet.personal_info.fullName = (!this.enrollCabinet.personal_info.surname ? '' : this.enrollCabinet.personal_info.surname)
      + ' ' + (!this.enrollCabinet.personal_info.firstname ? '' : this.enrollCabinet.personal_info.firstname)
      + ' ' + (!this.enrollCabinet.personal_info.patronymic ? '' : this.enrollCabinet.personal_info.patronymic);
  }

  private resetAlternativeColleges() {
    this.alternativeColleges.forEach(ac => {
      ac.specId = 0;
      ac.collegeId = 0;
      ac.qualificationId = 0;
      ac.entrance_exams_info.gpa = 0;
      this.resetData(ac.entrance_exams_info.mandatory_subjects);
      this.resetData(ac.entrance_exams_info.profile_subjects);
    });
  }

  resetData(subjects) {
    subjects.forEach(subject => {
      subject.subjectId = null;
      subject.points = 0;
      if (subject.subject) {
        subject.subject = null;
      }
    });
  }

  private loadAlternativeCollegeProfessions() {
    const profession = this.dics.professions.find(p => p.id === this.enrollCabinet.entrance_info.speciality);
    const arr = [];
    if (profession) {
      if (profession.professionTypeId == 16 || profession.professionTypeId == 24) {
        this.dics.professions
          .filter(p => p.professionTypeId == profession.professionTypeId)
          .forEach(p => {
            arr.push(p);
          });
      } else {
        this.dics.professions
          .filter(p => p.professionTypeId != 16 && p.professionTypeId != 24)
          .forEach(p => {
            arr.push(p);
          });
      }
    }
    this.dics.alternativeCollegeProfessions = arr;
    this.dics.alternativeCollegeProfessions.map((i) => {
      i.fullName = i.code + ' ' + i.name;
      return i;
    });
  }

  loadEducatedList() {
    this._dictionaryService.getDicEducatedList().subscribe(data => {
      let newVar;
      if (this.enrollCabinet.edu_info.edu_institute_graduate === 2) {
        newVar = edu => edu.id === 3;
      } else {
        newVar = h => h.id !== 4 && h.id !== 5 && h.id !== 3;
      }
      data = data.filter(newVar);
      this.dics.educated = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _dictionaryService.getDicEducatedList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
  }

  generatePassword() {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: 'password_generate.confirmation_applicant',
        acceptMessage: 'Continue',
        declineMessage: 'Cancel',
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._enrollApplicationService.generateLoginPassword(this.enrollId).subscribe(
          response => {
            const uuid = this._principal.generateUUID();
            localStorage.setItem(uuid, JSON.stringify(response.data));
            window.open('#/user/generate-login-password?uuid=' + uuid, '_blank');
          }
        );
      }
    });
  }

  // За данным абитуриентом остается закреплен образовательный грант по специальности {{speciality}} квалификации {{qualification}} в {{college}}. Вы подтверждаете, что возвращаете оригиналы документов абитуриентов в связи с получением гранта в другом колледже. Продолжить?
  private getDocumentReturnMessage() {
    let message = 'enroll_application_operations.documents_returned_confirm';
    this.actualizeData = true;
    console.log('finalGrant', this.enrollCabinet.finalGrant);
    if (this.enrollCabinet.finalGrant > 0) {
      let speciality = '';
      let qualification = '';
      let college = '';
      const finalGrant = this.enrollCabinet.finalGrant;
      console.log('this.alternativeColleges', this.alternativeColleges);
      this.alternativeColleges.forEach(c => {
        if (c.number == finalGrant) {
          console.log('this.alternativeCollegesProfessions', this.alternativeCollegesProfessions);
          this.alternativeCollegesProfessions.forEach(p => {
            if (p.id == c.specId) {
              speciality = p.code + ' ' + p.name;
              console.log('profession', p.name);
            }
          });
          console.log('this.alternativeCollegesQualificationArrays', this.alternativeCollegesQualificationArrays);
          this.alternativeCollegesQualificationArrays[finalGrant].forEach(q => {
            if (q.id == c.qualificationId) {
              qualification = q.code + ' ' + q.name;
              console.log('qualification', q.name);
            }
          });
          console.log('this.alternativeCollegesDictionary', this.alternativeCollegesDictionary);
          this.alternativeCollegesDictionary[finalGrant].forEach(col => {
            if (col.id == c.collegeId) {
              college = col.name;
              console.log('college', col.name);
            }
          });
        }
      });

      const param = {speciality: speciality, qualification: qualification, college: college};
      this._translateService.get('enroll_application_operations.alternative_college_documents_returned_confirm', param).subscribe((res: string) => {
        message = res;
      });
    }
    return message;
  }

  rejectGrant() {
    this.actualizeData = true;
    this._utils.confirmDialog({message: this.getRejectGrantMessage()}, () => {
      // this._utils.blockStart();
      this.dialog.closeAll();
      const dialogRef = this.getCommonDialogComponent('enroll_application_operations.reject_grant_dialog_title', 'save', 4);
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          if (this.statusInfo.rejectingGrantReason) {
            this.statusInfo.rejectingGrant = true;
            this._enrollApplicationService.rejectGrant(this.enrollCabinet.enrollId, this.statusInfo).subscribe(response => {
              this.enrollCabinet.grantRejectionStatus = response.description;
              this.enrollCabinet.applicantStatus = response.data;
              console.log(response);
            });
          }
        }
      });
    }, () => {
      console.log('cancel reject grant');
    });

  }

  getRejectGrantMessage() {
    let message = '';
    let speciality = '';
    let qualification = '';
    let college = '';
    const finalGrant = this.enrollCabinet.finalGrant;
    if (finalGrant > 0) {
      console.log('this.alternativeColleges', this.alternativeColleges);
      this.alternativeColleges.forEach(c => {
        if (c.number == finalGrant) {
          console.log('this.alternativeCollegesProfessions', this.alternativeCollegesProfessions);
          this.alternativeCollegesProfessions.forEach(p => {
            if (p.id == c.specId) {
              speciality = p.code + ' ' + p.name;
              console.log('profession', p.name);
            }
          });
          console.log('this.alternativeCollegesQualificationArrays', this.alternativeCollegesQualificationArrays);
          this.alternativeCollegesQualificationArrays[finalGrant].forEach(q => {
            if (q.id == c.qualificationId) {
              qualification = q.code + ' ' + q.name;
              console.log('qualification', q.name);
            }
          });
          console.log('this.alternativeCollegesDictionary', this.alternativeCollegesDictionary);
          this.alternativeCollegesDictionary[finalGrant].forEach(col => {
            if (col.id == c.collegeId) {
              college = col.name;
              console.log('college', col.name);
            }
          });
        }
      });
    } else if (finalGrant == 0) {
      college = this.enrollCabinet.centerCollege.nameRu;
      console.log('mainCollegeProfessionsDic',  this.mainCollegeProfessionsDic);
      this.mainCollegeProfessionsDic.forEach(p => {
        if (p.id == this.enrollCabinet.entrance_info.speciality) {
          speciality = p.code + ' ' + p.name;
        }
      });
      console.log('mainCollegeQualificationDic',  this.mainCollegeQualificationDic);
      this.mainCollegeQualificationDic.forEach(q => {
        if (q.id == this.enrollCabinet.entrance_info.qualification) {
          qualification = q.code + ' ' + q.name;
        }
      });
    }
    const param = {speciality: speciality, qualification: qualification, college: college};
    this._translateService.get('enroll_application_operations.reject_grant_confirm', param).subscribe((res: string) => {
      message = res;
    });
    return message;
  }

  private getGrantCompletionMessage() {
    this._enrollApplicationService.getGrantCompletionMessage(this.enrollCabinet.enrollId, this._translateService.currentLang).subscribe(response => {
      this.grantCompletionMessage = response.data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/enroll-cabinet.component.ts